import React from "react";
import { FlatButton } from "material-ui";
import uniq from "lodash/uniq";
import { formatPrice } from "../../util";

import CurrencyField from "./currency-field.jsx";
import Label from "./label.jsx";

const BUTTON_STYLE = {
  borderWidth: "1px",
  borderStyle: "solid",
  borderColor: "rgb(33, 33, 33)",
  marginRight: 7
};

const SELECTED_STYLE = {
  backgroundColor: "rgb(2, 136, 209)",
  color: "#fff",
  borderColor: "rgb(2, 136, 209)"
};

class CashChangeWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tendered: 0,
      hasEdited: false
    };
  }

  _makeRecommendedCashAmounts(total) {
    const fractional = total / 100,
      units = [1, 5, 10, 20, 50, 100];

    return uniq(
      [fractional].concat(
        units.map(u => (u > fractional ? u : Math.ceil(fractional / u) * u))
      )
    )
      .map(fractional => fractional && fractional * 100)
      .filter(u => !!u)
      .sort((a, b) => a - b)
      .slice(0, 3);
  }

  componentWillMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(props) {
    if (props.total !== this.props.total || !this.state.hasEdited) {
      this.setState({ tendered: props.total });
    }
  }

  render() {
    const { total } = this.props,
      { tendered } = this.state;

    const suggestedTenders = this._makeRecommendedCashAmounts(this.props.total),
      isCustomTender = suggestedTenders.indexOf(tendered) === -1;

    return (
      <div>
        <div>
          Collect {formatPrice(total)} in cash from the customer, then click
          "Place order".
        </div>
        <Label style={{ marginBottom: 0 }}>Cash tendered</Label>
        <div>
          {suggestedTenders.map(amount => {
            return (
              <FlatButton
                style={Object.assign(
                  {},
                  BUTTON_STYLE,
                  tendered === amount && SELECTED_STYLE
                )}
                labelStyle={{ verticalAlign: 0 }}
                label={formatPrice(amount, true)}
                onClick={() =>
                  this.setState({ hasEdited: true, tendered: amount })
                }
              />
            );
          })}
          <CurrencyField
            placeholder="$0.00"
            style={{ width: 75 }}
            inputStyle={{ color: "rgb(2, 136, 209)" }}
            value={isCustomTender ? this.state.tendered : 0}
            onChange={e =>
              this.setState({
                hasEdited: true,
                tendered: e.target.value === 0 ? total : e.target.value
              })
            }
          />
        </div>
        {tendered ? (
          <div>
            <Label style={{ marginTop: 5, marginBottom: 0 }}>Change due</Label>
            <div style={{ fontSize: "11pt" }}>
              {tendered < total ? (
                <span style={{ color: "red" }}>
                  Insufficient payment &ndash; {formatPrice(total - tendered)}{" "}
                  still owed.
                </span>
              ) : (
                <span>{formatPrice(tendered - total)}</span>
              )}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default CashChangeWidget;



// WEBPACK FOOTER //
// ./src/app/components/partials/cash-change-widget.jsx